import React, { memo } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Grid, Tooltip } from "@material-ui/core";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import { getDateTime } from "app/common/LocalFunction";

const CheckInHistoryElasticPopup = ({
    open,
    handleClose,
    searchData,
    pageData,
    handleChangeFormSearch,
}) => {
    const { t } = useTranslation();

    return (
        <PopupForm
            size="lg"
            title="Lịch sử thay đổi check in"
            open={open}
            handleClose={handleClose}
            formik={{
                initialValues: searchData,
            }}
            hideSubmit
        >
            <Grid container spacing={1}>
                <Grid item xs={12} className="mt-2">
                    <TableComponent
                        showOrdinalNumbers
                        titleNodata={t("noData")}
                        data={pageData?.content || []}
                        name="CheckInHistoryElasticTable"
                        showMoreButton
                        minWidth={"1000px"}
                        columns={[
                            {
                                field: "systemChangeTime",
                                title: t("TG hệ thống"),
                                render: (row) => getDateTime(row?.systemChangeTime),
                            },
                            {
                                field: "checkInTime",
                                title: t("TG Check in"),
                                render: (row) => getDateTime(row?.checkInTime),
                            },
                            {
                                field: "patient.fullName",
                                title: t("Tên khách hàng"),
                                render: (row) => (
                                    <div>
                                        <b>{row?.patient?.fullName}</b>
                                        <p style={{ color: "#4276a4", fontSize: "12px" }}>{row?.patient?.code}</p>
                                    </div>
                                ),
                            },
                            {
                                field: "companion.fullName",
                                title: t("Người đi cùng"),
                                render: (row) => (
                                    <div>
                                        <b>{row?.companion?.fullName}</b>
                                        <p style={{ color: "#4276a4", fontSize: "12px" }}>{row?.companion?.code}</p>
                                    </div>
                                ),
                            },
                            {
                                field: "department.name",
                                title: t("Cơ sở"),
                                render: (row) => row?.department?.name || "",
                            },
                            {
                                field: "receptionist.staffName",
                                title: t("Người check in"),
                                render: (row) => {
                                    const staff = row?.receptionist;
                                    return staff ? `${staff.staffName || ""}${staff.code ? ` (${staff.code})` : ""}` : "";
                                },
                            },
                            {
                                field: "currentTelesale.staffName",
                                title: t("Telesale"),
                                render: (row) => {
                                    const staff = row?.currentTelesale;
                                    return staff ? `${staff.staffName || ""}${staff.code ? ` (${staff.code})` : ""}` : "";
                                },
                            },
                            {
                                field: "currentPatientSource.name",
                                title: t("Nguồn"),
                                render: (row) => (
                                    <div>
                                        {row?.currentPatientSource?.name}
                                        {row?.currentPatientSourceDetail?.name && (
                                            <p style={{ fontSize: "11px", color: "#666" }}>
                                                - {row?.currentPatientSourceDetail?.name}
                                            </p>
                                        )}
                                    </div>
                                ),
                            },
                            {
                                field: "listConsultant",
                                title: t("Tư vấn viên"),
                                render: (row) => {
                                    if (!Array.isArray(row?.listConsultant) || row?.listConsultant.length === 0) return "";
                                    return row.listConsultant
                                        .map(c => `${c.staffName || ""}${c.code ? ` (${c.code})` : ""}`)
                                        .join(", ");
                                }
                            },
                            {
                                field: "userCreate.username",
                                title: t("TK thực hiện"),
                                render: (row) => row?.userCreate?.username || "",
                            },
                        ]}
                        dataPagination={{
                            pageIndex: searchData?.pageIndex,
                            pageSize: searchData?.pageSize,
                            totalElements: pageData?.totalElements,
                            totalPages: pageData?.totalPages,
                            setPageIndex: (pageIndex) => handleChangeFormSearch({ pageIndex }),
                            setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
                        }}
                    />
                </Grid>
            </Grid>
        </PopupForm>
    );
};

export default memo(observer(CheckInHistoryElasticPopup));
